import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import { WIZARD_URL_FRAGMENT } from '../../constants/Navigation';
import UsageTracker from '../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecommendationsResetModal = ({
  onClose
}) => {
  const handleUpdateClick = () => {
    UsageTracker.track('interaction', {
      action: 'catalog-recommendation-reset-modal-update'
    });
  };
  const handleCloseClick = () => {
    UsageTracker.track('interaction', {
      action: 'catalog-recommendation-reset-modal-close'
    });
    onClose();
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.resetLink.infoModalHeader"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: () => handleCloseClick()
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.resetLink.infoModalMessage"
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIRouterButton, {
        onClick: handleUpdateClick,
        to: WIZARD_URL_FRAGMENT,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.resetLink.infoModalUpdate"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: handleCloseClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.resetLink.infoModalClose"
        })
      })]
    })]
  });
};
export default RecommendationsResetModal;